<template>
  <!-- <div
    class="touch-zoom"
    @touchstart="handleTouchStart"
    @touchmove="handleTouchMove"
    @touchend="handleTouchEnd"
  >
    <img src='../assets/admin1.png' :style="imageStyle" />
  </div> -->
  <div class="demo" style="width: 100px;height: 150px;">
    <img src="../assets/admin1.png" >
  </div>
  </template>
   
  <script>
  export default {
    // data() {
    //   return {
    //     imageSrc: '../assets/background.jpg',
    //     start: { x: 0, y: 0 },
    //     end: { x: 0, y: 0 },
    //     scale: 1,
    //   };
    // },
    // computed: {
    //   imageStyle() {
    //     return {
    //       transform: `scale(${this.scale})`,
    //       transition: 'transform 0.1s ease-in-out',
    //     };
    //   },
    // },
    // methods: {
    //   handleTouchStart(e) {
    //     alert(e.touches.length)
    //     if (e.touches.length === 2) { // 确保是两指同时触摸
    //       this.start = {
    //         x: (e.touches[0].pageX + e.touches[1].pageX) / 2,
    //         y: (e.touches[0].pageY + e.touches[1].pageY) / 2,
    //       };
    //     }
    //   },
    //   handleTouchMove(e) {
    //     if (e.touches.length === 2) {
    //       this.end = {
    //         x: (e.touches[0].pageX + e.touches[1].pageX) / 2,
    //         y: (e.touches[0].pageY + e.touches[1].pageY) / 2,
    //       };
    //       const distanceStart = this.distance(this.start, this.end);
    //       this.scale = distanceStart / this.distance(this.start, this.start);
    //     }
    //   },
    //   handleTouchEnd(e) {
    //     if (e.touches.length === 0) {
    //       this.start = { x: 0, y: 0 };
    //       this.end = { x: 0, y: 0 };
    //     }
    //   },
    //   distance(p1, p2) {
    //     return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
    //   },
    // }
    data(){
      return{
        zoom:1
      }
    },
    mounted(){
      const content = document.querySelector('.demo')//获取需要放大缩小的盒子
      let firstDistance = 0 //存放手指开始放上的时候，两根手指之间的距离
      // 缩放事件的处理
      const getDistance = (start,stop) => {
        // 计算两根手指之间的距离
        return Math.sqrt(Math.pow(Math.abs(start.x - stop.x),2) + Math.pow(Math.abs(start.y - stop.y),2))
      }
      content.addEventListener('touchstart',function(event){
        // 获取第一次触摸的点
        const touches = event.touches
        if(touches.length > 1){// 判断是否是两指
          const events1 = touches[0]
          const events2 = touches[1]
          const one = {
            x:events1.pageX,//第一根手指的横坐标
            y:events1.pageY,//第一根手指的纵坐标
          }
          const two = {
            x:events2.pageX,//第二根手指的横坐标
            y:events2.pageY,//第二根手指的纵坐标
          }
          firstDistance = getDistance(one,two)
        }
      })
      document.addEventListener('touchmove',(event) => {
        const touches = event.touches
        if(touches.length > 1){
          const events1 = touches[0]
          const events2 = touches[1]
          const one = {
            x:events1.pageX,//第一根手指的横坐标
            y:events1.pageY,//第一根手指的纵坐标
          }
          const two = {
            x:events2.pageX,//第二根手指的横坐标
            y:events2.pageY,//第二根手指的纵坐标
          }
          const distance = getDistance(one,two)
          let zoom = distance / firstDistance
          content.style.zoom = this.zoom * zoom
        }
      })
      document.addEventListener('touchend',(event) => {
        this.zoom = content.style.zoom
      })
    },
  };
  </script>
   
  <style>
  .touch-zoom {
    width: 100%;
    height: 400px;
    overflow: hidden;
    touch-action: none; /* 防止触摸时浏览器默认行为 */
  }
   
  .touch-zoom img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  </style>